document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fluido-pdp-main-image-wrap').forEach(function (wrap) {
    wrap.addEventListener('mousemove', function (e) {
      var rect = wrap.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1);
      var y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1);
      wrap.style.setProperty('--zoom-x', x + '%');
      wrap.style.setProperty('--zoom-y', y + '%');
    });
    wrap.addEventListener('mouseleave', function () {
      wrap.style.setProperty('--zoom-x', '50%');
      wrap.style.setProperty('--zoom-y', '50%');
    });
  });
});
